import React, { useState } from 'react';
import { getFirestore, collection, addDoc } from 'firebase/firestore';
import { getStorage, ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import { useNavigate } from 'react-router-dom';
import './AjoutPlanche1.css';

function AjoutPlanche1() {
  const navigate = useNavigate();
  const [titre, setTitre] = useState('');
  const [fichier, setFichier] = useState<File | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files[0]) {
      const file = e.target.files[0];
      // Vérifier que c'est bien un PDF
      if (file.type !== 'application/pdf') {
        setError('Veuillez sélectionner un fichier PDF');
        return;
      }
      setFichier(file);
      setError('');
    }
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!fichier || !titre) {
      setError('Veuillez remplir tous les champs');
      return;
    }

    try {
      setLoading(true);
      setError('');

      // Upload du fichier dans Firebase Storage
      const storage = getStorage();
      const timestamp = Date.now();
      const fileRef = ref(storage, `planche1/${timestamp}_${fichier.name}`);
      await uploadBytes(fileRef, fichier);
      const fileUrl = await getDownloadURL(fileRef);

      // Ajout des références dans Firestore
      const db = getFirestore();
      await addDoc(collection(db, 'Planches1'), {
        titre: titre,
        fichier: fileUrl,
        nomFichier: fichier.name,
        dateUpload: timestamp,
        type: 'planche1'
      });

      navigate('/mapage/planche-1');
    } catch (err) {
      console.error('Erreur:', err);
      setError('Une erreur est survenue lors de l\'ajout de la planche');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="ajout-planche-container">
      <h2>Ajouter une planche</h2>
      <form onSubmit={handleSubmit} className="ajout-planche-form">
        <div className="form-group">
          <label htmlFor="titre">Titre:</label>
          <input
            type="text"
            id="titre"
            value={titre}
            onChange={(e) => setTitre(e.target.value)}
            placeholder="Entrez le titre de la planche"
            required
            className="form-input"
          />
        </div>

        <div className="form-group">
          <label htmlFor="fichier">Document PDF:</label>
          <input
            type="file"
            id="fichier"
            accept=".pdf"
            onChange={handleFileChange}
            required
            className="form-input"
          />
          <small className="form-help">Format accepté: PDF uniquement</small>
        </div>

        {error && <div className="error-message">{error}</div>}

        <div className="buttons-container">
          <button
            type="button"
            onClick={() => navigate('/mapage/planche-1')}
            className="cancel-btn"
          >
            Annuler
          </button>
          <button
            type="submit"
            disabled={loading}
            className="submit-btn"
          >
            {loading ? 'Ajout en cours...' : 'Ajouter'}
          </button>
        </div>
      </form>
    </div>
  );
}

export default AjoutPlanche1;